import { ToggleGroup } from '@/components/play'
import { WorkspaceInfo } from '@/components/workspace/WorkspaceInfo'
import { useIngestRegions } from '@/hooks/useIngestRegions'

interface Props {
  value: string
  onChange: (region: string) => void
  disabled?: boolean
}

/** Region pills for where an event's cameras connect. Hidden when there's only one region to use. */
export function IngestRegionPicker({ value, onChange, disabled = false }: Props) {
  const regions = useIngestRegions()
  if (regions.length < 2) return null

  return (
    <div className="flex items-center gap-1">
      <ToggleGroup
        label="Region"
        items={regions.map(({ id, name }) => ({ value: id, label: name, disabled }))}
        value={value}
        onValueChange={onChange}
      />
      <WorkspaceInfo label="About regions">
        Where your cameras connect. Choose the one nearest them. It can't change while a camera is live.
      </WorkspaceInfo>
    </div>
  )
}
